module.exports = require("npm:sticky-sidebar@3.2.1/dist/sticky-sidebar.js");